import {
  QueryFunction,
  QueryKey,
  useQuery,
  UseQueryOptions,
} from "@tanstack/react-query";
import { App } from "antd";
import { handleError } from "api";
import {
  BookingApiService,
  GetRecurringBookingsParams,
  recurringBookingsQueryKeys,
  RecurringBookingsResponse,
} from "features/bookings";

const { getRecurringBookings } = BookingApiService();

const getBookingsQuery = (
  params: any,
  options?: UseQueryOptions<any>
): {
  queryKey: QueryKey;
  queryFn: QueryFunction<RecurringBookingsResponse>;
  options?: UseQueryOptions<RecurringBookingsResponse>;
} => ({
  queryKey: recurringBookingsQueryKeys.list(params),
  queryFn: ({ signal }) => getRecurringBookings(params, { config: { signal } }),
  ...options,
});

export const useGetRecurringBookings = (
  params: GetRecurringBookingsParams,
  options?: UseQueryOptions<RecurringBookingsResponse>
) => {
  const { message } = App.useApp();

  return useQuery<RecurringBookingsResponse, Error>(
    getBookingsQuery(params, {
      onError: (error: unknown) => {
        const uiMessage = handleError(error);

        message.error(uiMessage);
      },
      ...options,
    })
  );
};
